import { hooksStore } from "../../stores/hooks.store";
import { tempStore } from "../../stores/temp.store";

import { config } from "./config";

import { ulozRozkopavku } from "../../api/rozkopavky";
import { zobrazRozkopavku } from "./rozkopavky.func";

import { getMap } from "../../helpers/map";
import { vratVrstvyMapyPodlaTypu } from "../../helpers/config";

import { get as get_store } from "svelte/store";
import get from "get-value";
import moment from "moment";
import "moment/locale/sk";
moment.locale("sk");
import Dropzone from "dropzone";

const port = location.port || (location.protocol === "https:" ? "443" : "80");

export let tempFiles = {
  cislo_rz_files_array: [],
  poznamka_files_array: [],
  fotografia_pred_files_array: [],
  fotografia_po_files_array: [],
};

export function dropzoneInit(inputName, formData) {
  let cislo_rz_dz = new Dropzone(
    `#${config.moduleName}_${inputName.slice(0, -6)}_dz`,
    {
      url: `${__myapp.env.API_URL}:${port}/${__myapp.env.API_PATH}/api/v1/smartmap/file/${config.moduleName}`,
      paramName: "files",
      maxFilesize: 50,
      withCredentials: true,
      uploadMultiple: true,
      addRemoveLinks: true,
      dictDefaultMessage: "Presunte súbory pre nahratie sem.",
      dictFallbackMessage:
        "Váš prehliadač nepodporuje drag'n'drop nahrávanie súborov.",
      dictFileTooBig:
        "Súbor je príliš veľký ({{filesize}}MiB). Maximálna veľkosť: {{maxFilesize}}MiB.",
      dictInvalidFileType: "Tento typ súbory nie je povolený.",
      dictResponseError: "Server odpovedal {{statusCode}} kódom.",
      dictCancelUpload: "Zrušiť nahrávanie.",
      dictUploadCanceled: "Nahrávanie zrušené.",
      dictCancelUploadConfirmation:
        "Ste si istý, že chcete prerušiť nahrávanie?",
      dictRemoveFile: "Odstrániť",
    }
  );
  cislo_rz_dz
    .on("removedfile", (file) => {
      tempFiles[`${inputName}_array`] = tempFiles[`${inputName}_array`].filter(
        (obj) => obj.filename !== file.name
      );
      hooksStore.applyFilters(
        `${config.moduleName}_aktualizujInput`,
        formData[inputName],
        tempFiles[`${inputName}_array`]
      );
    })
    .on("successmultiple", function (file, response) {
      if (response.data) {
        response.data.forEach((file) => {
          tempFiles[`${inputName}_array`].push({
            id: file.id,
            filename: file.file_name,
          });
        });
        hooksStore.applyFilters(
          `${config.moduleName}_aktualizujInput`,
          formData[inputName],
          tempFiles[`${inputName}_array`]
        );
      }
    })
    .on("addedfile", function (file) {
      let link = document.createElement("a");
      link.setAttribute("href", file.imageUrl);
      link.setAttribute("target", "_blank");
      link.innerHTML = file.file_name;
      file.previewElement.querySelector(
        ".dz-details .dz-filename span"
      ).innerHTML = "";
      file.previewElement
        .querySelector(".dz-details .dz-filename span")
        .appendChild(link);
    });

  return { name: inputName, dz: cislo_rz_dz };
}

export async function ulozit(popup, form) {
  hooksStore.applyFilters(
    `${config.moduleName}_aktualizujSubmit`,
    "Ukladanie ."
  );
  let kresleniaKRozkopavke = [];
  let count = 0;
  let interval = setInterval(() => {
    if (count % 3 === 0) {
      count = 1;
    } else {
      count++;
    }
    hooksStore.applyFilters(
      `${config.moduleName}_aktualizujSubmit`,
      "Ukladanie " + ".".repeat(count)
    );
  }, 300);

  const formData = new FormData(form);
  const data = {};
  for (let field of formData) {
    const [key, value] = field;
    if (key.indexOf("datum_") !== -1) {
      if (value) {
        const d = new Date(value);
        const date = moment(d);
        data[key] = date.format("L");
      } else {
        data[key] = null;
      }
    } else {
      data[key] = value;
    }
  }

  if (get(data, "layers") === "") {
    hooksStore.applyFilters(`${config.moduleName}_formMessages`, {
      errors: ["Je potrebné zvoliť aspon jedno aktívne kreslenie."],
      successes: [],
    });
    clearInterval(interval);
    hooksStore.applyFilters(`${config.moduleName}_aktualizujSubmit`, "Uložiť");
    return;
  }

  if (data.id) {
    kresleniaKRozkopavke =
      get(get_store(tempStore), `kreslenia_${config.moduleName}.${data.id}`) ||
      {};
  }

  const layerData = JSON.parse(data.layers);
  for (let i = 0; i < layerData.features.length; i++) {
    layerData.features[i].properties.description = "";
  }
  data.layers = JSON.stringify(layerData);

  let aktiveVsetkyPovodneKreslenia = true;
  if (kresleniaKRozkopavke) {
    aktiveVsetkyPovodneKreslenia = kresleniaKRozkopavke.every((pid) => {
      return layerData.features.some((l) => l.id === pid);
    });
  }

  if (
    aktiveVsetkyPovodneKreslenia === false &&
    confirm(config.texts.editPovodneKreslenia) === false
  ) {
    clearInterval(interval);
    hooksStore.applyFilters(`${config.moduleName}_aktualizujSubmit`, "Uložiť");
    return;
  }

  const loginResponse = await ulozRozkopavku(config.type, data);
  if (loginResponse.success) {
    hooksStore.applyFilters(`${config.moduleName}_formReset`);
    if (get(data, "sourceId")) {
      hooksStore.doAction("odstranVrstvuZMapy", get(data, "sourceId"));
    }
    if (get(popup, "source_id_parent")) {
      const map = getMap();
      if (map.getSource(popup.source_id_parent)) {
        hooksStore.doAction("odstranVrstvuZMapy", popup.source_id_parent);
      }
    }

    for (let i = 0; i < layerData.features.length; i++) {
      hooksStore.doAction("zmazKonkretneKreslenie", layerData.features[i].id);
    }
    setTimeout(() => {
      hooksStore.applyFilters(`${config.moduleName}_formMessages`, {
        errors: [],
        successes: [],
      });
      hooksStore.doAction(`${config.moduleName}_skryFormular`);
    }, 3000);

    if (popup) {
      popup.remove();
    }

    const vrstvy = vratVrstvyMapyPodlaTypu(config.moduleName);
    zobrazRozkopavku(loginResponse.data[0], vrstvy);
  }

  hooksStore.applyFilters(`${config.moduleName}_formMessages`, {
    errors: loginResponse.errors,
    successes: loginResponse.successes,
  });
  clearInterval(interval);
  hooksStore.applyFilters(`${config.moduleName}_aktualizujSubmit`, "Uložiť");
}
